import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { Controller } from 'react-hook-form';
import AccordionCard from '../../../Shared/Components/AccordionCard/AccordionCard';
import InfoIcon from '@mui/icons-material/Info';
import type { InvoicePfronRefundSectionProps } from './InvoicePfronRefundSection.types';

const InvoicePfronRefundSection: React.FC<InvoicePfronRefundSectionProps> = ({
  control,
  errors,
}) => {
  return (
    <AccordionCard
      title="Szczegóły refundacji PFRON"
      icon={<InfoIcon color="primary" />}
      defaultExpanded={true}
    >
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }} >
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Pola poniżej są wymagane tylko dla faktur typu "Refund" (zwrot PFRON).
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }} >
          <Controller
            name="refundParticipantReferralCost"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Koszt skierowania za uczestnika"
                type="number"
                fullWidth
                inputProps={{ step: '0.01', min: '0' }}
                error={!!errors.refundParticipantReferralCost}
                helperText={errors.refundParticipantReferralCost?.message as string}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value ? Number(e.target.value) : undefined)
                }
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }} >
          <Controller
            name="refundGuardianReferralCost"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Koszt skierowania za opiekuna"
                type="number"
                fullWidth
                inputProps={{ step: '0.01', min: '0' }}
                error={!!errors.refundGuardianReferralCost}
                helperText={errors.refundGuardianReferralCost?.message as string}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value ? Number(e.target.value) : undefined)
                }
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }} >
          <Controller
            name="refundPfronSubsidyParticipant"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Dofinansowanie PFRON - uczestnik"
                type="number"
                fullWidth
                inputProps={{ step: '0.01', min: '0' }}
                error={!!errors.refundPfronSubsidyParticipant}
                helperText={errors.refundPfronSubsidyParticipant?.message as string}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value ? Number(e.target.value) : undefined)
                }
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }} >
          <Controller
            name="refundPfronSubsidyGuardian"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Dofinansowanie PFRON - opiekun"
                type="number"
                fullWidth
                inputProps={{ step: '0.01', min: '0' }}
                error={!!errors.refundPfronSubsidyGuardian}
                helperText={errors.refundPfronSubsidyGuardian?.message as string}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value ? Number(e.target.value) : undefined)
                }
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }} >
          <Controller
            name="refundOwnContribution"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Dopłata własna"
                type="number"
                fullWidth
                inputProps={{ step: '0.01', min: '0' }}
                error={!!errors.refundOwnContribution}
                helperText={errors.refundOwnContribution?.message as string}
                value={field.value ?? ''}
                onChange={(e) =>
                  field.onChange(e.target.value ? Number(e.target.value) : undefined)
                }
              />
            )}
          />
        </Grid>
      </Grid>
    </AccordionCard>
  );
};

export default InvoicePfronRefundSection;
